import * as React from 'react';
import { observer } from 'mobx-react';

/**
 * 静音循环视频
 * @param className
 * @param cover
 * @param src
 * @param autoPlay
 * @param callback;
 * @returns {JSX.Element}
 * @constructor
 */
const SilentVideo = React.forwardRef(({ className, cover, src, autoPlay = true, callback = function() {}, muted = true, ...rest }, ref) => {
  return <video ref={ref} className={className} poster={cover} src={src} muted={muted} loop autoPlay={autoPlay} onCanPlayThrough={callback} {...rest} />;
});

export default observer(SilentVideo);
